var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookingPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2495 16.4406C11.5585 16.7164 11.5853 17.1905 11.3095 17.4995L7.73803 21.4995C7.59574 21.6589 7.39223 21.75 7.17858 21.75C6.96493 21.75 6.76142 21.6589 6.61913 21.4995L5.19055 19.8995C4.91468 19.5905 4.94152 19.1164 5.2505 18.8406C5.55947 18.5647 6.03359 18.5915 6.30946 18.9005L7.17858 19.8739L10.1906 16.5005C10.4664 16.1915 10.9405 16.1647 11.2495 16.4406Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2495 25.4406C11.5585 25.7164 11.5853 26.1905 11.3095 26.4995L7.73803 30.4995C7.59574 30.6589 7.39223 30.75 7.17858 30.75C6.96493 30.75 6.76142 30.6589 6.61913 30.4995L5.19055 28.8995C4.91468 28.5905 4.94152 28.1164 5.2505 27.8406C5.55947 27.5647 6.03359 27.5915 6.30946 27.9005L7.17858 28.8739L10.1906 25.5005C10.4664 25.1915 10.9405 25.1647 11.2495 25.4406Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8701 18.0115C15.8701 17.0115 16.8701 17.0115 16.8701 17.0115H17.8701C17.9695 17.0115 18.8701 17.4592 18.8701 18.0115C18.8701 18.5638 18.9695 19.0115 18.8701 19.0115H16.8701C16.7707 19.0115 15.8701 19.0115 15.8701 18.0115Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24C16 23.5858 16.3358 23.25 16.75 23.25H27.75C28.1642 23.25 28.5 23.5858 28.5 24C28.5 24.4142 28.1642 24.75 27.75 24.75H16.75C16.3358 24.75 16 24.4142 16 24Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C16 29.5858 16.3358 29.25 16.75 29.25H27.75C28.1642 29.25 28.5 29.5858 28.5 30C28.5 30.4142 28.1642 30.75 27.75 30.75H16.75C16.3358 30.75 16 30.4142 16 30Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7362 4.74994C12.5981 4.74994 12.4862 4.86187 12.4862 4.99994V5.59994C12.4862 6.01415 12.1504 6.34994 11.7362 6.34994H9.53619C9.39812 6.34994 9.28619 6.46187 9.28619 6.59994V10.9999C9.28619 11.138 9.39812 11.2499 9.53619 11.2499H16.2824C16.4205 11.2499 16.5 10.6381 16.5 10.5L17 7.99999C17 7.86192 17.6381 6.99999 17.5 6.99999L18 5.99999C18.5 5.49999 18.7862 5.16415 18.7862 4.74994H18.8244C19.3244 4.89994 18.9625 4.74994 18.8244 4.74994H12.7362ZM10.9925 4.84994C11.0686 3.95366 11.8202 3.24994 12.7362 3.24994H19.8615C20.7775 3.24994 20.9239 3.10371 21 3.99999L19 5.99999C19 6.49999 18 7.03349 18 7.99999L17 12C17 12.9665 17.2998 12.7499 16.4423 12.7499H9.53619C8.5697 12.7499 7.78619 11.9664 7.78619 10.9999V6.59994C7.78619 5.63344 8.56969 4.84994 9.53619 4.84994H10.9925Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 11C1.5 10.3096 2.05964 9.75 2.75 9.75H8.75V8.25H2.75C1.23122 8.25 0 9.48122 0 11V34C0 35.5188 1.23122 36.75 2.75 36.75H27.1021C26.914 36.2758 26.7975 35.7705 26.7618 35.25H2.75C2.05964 35.25 1.5 34.6904 1.5 34V11ZM32 30.1884C32.0846 30.1276 32.168 30.0648 32.25 30C32.6357 30.3264 33.0556 30.6035 33.5 30.8281V21C33.5 19.4812 33.5 22 33.5 21L32 21.5C32 22 32 20.8096 32 21.5V30.1884Z",
    fill: "inherit"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 39.8401L34.7766 38.3554C35.9992 37.637 36.75 36.3249 36.75 34.9068L36.75 32.5104L36.6093 32.5145C35.0457 32.5601 33.5149 32.11 32.2313 31.2394C30.9683 32.0471 29.4958 32.4808 27.9858 32.4808L27.75 32.4808L27.75 34.9068C27.75 36.3249 28.5008 37.637 29.7234 38.3554L32.25 39.8401ZM32.25 30C33.4573 31.0215 34.9993 31.561 36.5801 31.5149L37.75 31.4808L37.75 34.9068C37.75 36.6794 36.8115 38.3195 35.2832 39.2176L32.25 41L29.2168 39.2176C27.6885 38.3195 26.75 36.6794 26.75 34.9068L26.75 31.4808L27.9858 31.4808C29.5333 31.4808 31.0356 30.9591 32.25 30Z",
    fill: "inherit"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6392 33.1217C34.782 33.2897 34.7875 33.569 34.6515 33.7454L31.4769 37.8631C31.4077 37.9529 31.3111 38.0025 31.2107 37.9999C31.1104 37.9973 31.0156 37.9426 30.9495 37.8493L29.8384 36.2807C29.7085 36.0973 29.7235 35.8186 29.872 35.6582C30.0204 35.4977 30.246 35.5163 30.3759 35.6997L31.2294 36.9046L34.1342 33.1369C34.2703 32.9605 34.4963 32.9537 34.6392 33.1217Z",
    fill: "inherit"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 1.75C22.0891 1.75 17.5 6.33908 17.5 12C17.5 17.6609 22.0891 22.25 27.75 22.25C33.4109 22.25 38 17.6609 38 12C38 6.33908 33.4109 1.75 27.75 1.75ZM16 12C16 5.51065 21.2607 0.25 27.75 0.25C34.2393 0.25 39.5 5.51065 39.5 12C39.5 18.4893 34.2393 23.75 27.75 23.75C21.2607 23.75 16 18.4893 16 12Z",
    fill: "inherit"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 8.07377C21.75 6.92846 22.6722 6 23.8097 6H31.6903C32.8278 6 33.75 6.92846 33.75 8.07377V14.9262C33.75 16.0715 32.8278 17 31.6903 17H23.8097C22.6722 17 21.75 16.0715 21.75 14.9262V8.07377ZM24.0577 7C23.2169 7 22.6731 7.22724 22.6731 8.07377V15C22.6731 15.8465 22.9689 16 23.8097 16H31.6903C32.5311 16 32.8269 15.7728 32.8269 14.9262V8.07377C32.8269 7.22724 32.5311 7 31.6903 7H24.0577Z",
    fill: "inherit"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.25 5C30.5261 5 30.75 5.08954 30.75 5.2V6.8C30.75 6.91046 30.5261 7 30.25 7C29.9739 7 29.75 6.91046 29.75 6.8V5.2C29.75 5.08954 29.9739 5 30.25 5Z",
    fill: "inherit"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 5C25.5261 5 25.75 5.08954 25.75 5.2V6.8C25.75 6.91046 25.5261 7 25.25 7C24.9739 7 24.75 6.91046 24.75 6.8V5.2C24.75 5.08954 24.9739 5 25.25 5Z",
    fill: "inherit"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 9.5C21.75 9.22386 21.8703 9 22.0187 9H33.4813C33.6297 9 33.75 9.22386 33.75 9.5C33.75 9.77614 33.6297 10 33.4813 10H22.0187C21.8703 10 21.75 9.77614 21.75 9.5Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPolicy);
export default __webpack_public_path__ + "static/media/BookingPolicy.8d5fed2396e1b18ee67a604879f9bfe5.svg";
export { ForwardRef as ReactComponent };